"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colors_1 = require("./colors");
exports.customColors = {
    colorBorderWarning: colors_1.colors.Y500,
    colorBorderSuccess: colors_1.colors.Grn400,
    // baseColor: colors.B50,
    // colorTextLink: colors.B500,
    // baseRestColor: colors.B500,
    // baseHoverColor: colors.B600,
    // baseActiveColor: colors.B700,
    // baseDisabledColor: colors.G200,
    // darkRestColor: colors.G500,
    // darkHoverColor: colors.G600,
    darkActiveColor: colors_1.colors.G800
};
//# sourceMappingURL=customColors.js.map